import React from 'react'
import LoginFrame from '../shared/LoginFrame'
import AuthCollage from '../icons/AuthCollageIcon'
import { eventHandler } from '../../types.d'
import { useAppDispatch } from '../../store/store'
import { completeAuthFlow } from '../../store'
import {
  InjectedFrameProps,
  withFrameProps,
} from '../../context/withFrameProps'
import { preventDefault } from '../../helpers'

type PureCreatePasskeyErrorTerminalProps = {
  onContinue: eventHandler
} & Exclude<InjectedFrameProps, 'hasPreviousStep'>

export const PureCreatePasskeyErrorTerminal = ({
  onContinue,
  error,
  loading,
  logoUrl = null,
}: PureCreatePasskeyErrorTerminalProps) => (
  <LoginFrame
    title={null}
    disableError={true}
    recaptchaSiteKey={null}
    {...{ loading, logoUrl }}
  >
    <div className="space-y-4">
      <div className="flex items-center justify-center">
        <AuthCollage />
      </div>
      <p className="text-center font-medium text-lg">
        We couldn't create your passkey
      </p>

      <div
        className="text-center !mt-4 !mb-0 font-medium p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50"
        role="alert"
      >
        {error}
      </div>
    </div>
    <button
      onClick={preventDefault(onContinue)}
      type="submit"
      tabIndex={1}
      className="w-full text-white bg-slate-600 hover:bg-slate-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
    >
      Skip & Continue
    </button>
  </LoginFrame>
)

const BoundCreatePasskeyError = withFrameProps(
  PureCreatePasskeyErrorTerminal,
  {},
)

export const CreatePasskeyError = () => {
  const dispatch = useAppDispatch()

  const handleContinue = (e: React.MouseEvent<HTMLButtonElement>) => {
    dispatch(completeAuthFlow({ action: 'skip' }))
  }

  return <BoundCreatePasskeyError onContinue={handleContinue} />
}

export default CreatePasskeyError
